import React from 'react';
import ProcessingIndicator from '../Common/ProcessingIndicator';

class PageContent extends React.Component {
  state = {
    initializationComplete: false,
    initializationErrors: []
  }
  config = null;
  componentDidMount() {
    const {
      config
    } = this.props;

    config.loadConfig().then(config => {
      this.config = config;

      this.setState({
        initializationComplete: true
      });
    }, errors => {
      this.setState({
        initializationComplete: true,
        initializationErrors: errors
      });
    });
  }

  renderInitializationMessage() {
    const {
      initializationComplete,
      initializationErrors
    } = this.state;

    const {
      errorMessage,
      loadingMessage
    } = this.props;

    if (!initializationComplete) {
      return (
        <div className="parkchirp--page--user-message-container">
          <ProcessingIndicator userMessage={loadingMessage} />
        </div>
      );
    }

    if (initializationErrors.length) {
      return (
        <div className="parkchirp--page--user-message-container">
          <div className="parkchirp--page--user-message">
            <p>{errorMessage}</p>
            <ul>
              {initializationErrors.map(error =>
                <li key={performance.now()}>{error}</li>
              )}
            </ul>
          </div>
        </div>
      );
    }
  }

  render() {
    const {
      initializationComplete,
      initializationErrors
    } = this.state;

    const {
      className,
      renderContent
    } = this.props;

    return (
      <div className={className}>
        {(!initializationComplete || initializationErrors.length > 0) &&
          this.renderInitializationMessage()
        }
        {(initializationComplete && initializationErrors.length === 0) &&
          renderContent(this.config)
        }
      </div>
    )
  }
}

export default PageContent;